export default "__VITE_ASSET__FqUuWGY3__"